import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconGroupChatSvg } from "./IconGroupChatSvg.mjs";
const IconGroupChat = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconGroupChatSvg, ...iconProps });
};
export {
  IconGroupChat
};
